import classNames from "classnames";
import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { Transition, CSSTransition } from "react-transition-group";

export interface IDropdownPrimary {
    label: string;
    children: any;
    cssWrapper?: string;
    cssButton?: string; //className suffix for <button> element
}

export const DropdownPrimary = (props: IDropdownPrimary) => {
    const wrapperRef = useRef(null);

    const { label } = props;
    const [isOpen, setIsOpen] = useState(false);

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {setIsOpen(false);}
    };

    const ToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={classNames("primary-dropdown", props.cssWrapper)} ref={wrapperRef}>
            <button
                className={classNames("trigger", props.cssButton)}
                onClick={() => ToggleDropdown()}
                aria-expanded={isOpen}
                aria-haspopup="true"
            >
                <span className="text">{label}</span>
                <span className="icon" aria-hidden={true} />
            </button>

            <CSSTransition
                timeout={300}
                classNames="a-dropdown"
                in={isOpen}
                unmountOnExit
            >
               
                <div className="dropdown-list" aria-hidden={!isOpen}>
                    <div className="dropdown-list-panel">{props.children}</div>
                </div>
              
            </CSSTransition>
        </div>
    );
};
